var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noDataBox"},[_c('div',{staticClass:"noData"},[_c('img',{attrs:{"src":require("../../assets/img/noData.png"),"alt":""}}),_c('div',{staticClass:"text flexBox"},[_vm._t("tips")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }